import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import Flex from '../../generic/Flex';
import { icons, IconText } from '../../generic/Icon';
import Toggle from '../../generic/Toggle';
import { thirdPartyFetchersMap } from '../../../../shared/fetchers';

type RiskRuleComponentProps = {
  title: string;
  description: string;
  supportedFetchers: string[];
  isEnabled: boolean,
  onToggle: () => void;
};

const RiskRuleComponent: VoidFunctionComponent<RiskRuleComponentProps> = ({
  title,
  description,
  supportedFetchers,
  isEnabled,
  onToggle,
}) => {
  const ecosystemListStr = useMemo(() => supportedFetchers.map((fetcher) => thirdPartyFetchersMap[fetcher as keyof typeof thirdPartyFetchersMap]).sort().join(', '), [supportedFetchers]);

  const severityText = useMemo(
    () =>
      `This feature is supported for ${ecosystemListStr} projects.`,
    [ecosystemListStr],
  );

  return (
    <div className="card risk-rule-container">
      <div className="risk-details">
        <span className="risk-title">{title}</span>
        <div className="risk-description">
          {description}
        </div>
        <div className="risk-severity">
          <IconText
            icon={icons.infoCircle}
            text={severityText}
          />
        </div>
      </div>
      <Flex gap={10}>
        <Toggle
          checked={isEnabled}
          onChange={onToggle}
        />
        <div className="risk-toggle-label">
          {isEnabled ? 'Enabled' : 'Disabled'}
        </div>
      </Flex>
    </div>
  );
};

export default RiskRuleComponent;
